/* VELUN · Duft-Finder – Logik für sections/velun-finder.liquid */
/* Vorstart: Hat KEIN Duft Bestand (oder Editor-Vorschau), zeigt das Ergebnis "Bald erhältlich" statt Warenkorb-Button.
   Kehrt automatisch zurück, sobald Bestand gesetzt ist (Funktion soonMode). */
(function () {
  if (window.__vdfLoaded) return;
  window.__vdfLoaded = true;

  /*RANK-START*/
  var ROOMS = {
    zuhause: { 'Zuhause': 1 },
    arbeit: { 'Büro': 1, 'Praxis': 1, 'Empfang': 0.5 },
    gaeste: { 'Empfang': 1, 'Hotel': 1, 'Showroom': 0.8, 'Boutique / Retail': 0.8, 'Zuhause': 0.3 },
    wellness: { 'Wellness': 1, 'Hotel': 0.5 }
  };
  var MOODS = {
    frisch: { atm: { 'Frisch & Belebend': 1, 'Klar & Rein': 0.5 }, w: 1.5 },
    ruhig: { atm: { 'Ruhig & Entspannend': 1, 'Klar & Rein': 0.8 }, w: 2 },
    warm: { atm: { 'Warm & Geborgen': 1 }, w: 4.5 },
    elegant: { atm: { 'Elegant & Hochwertig': 1, 'Markant & Charaktervoll': 0.8 }, w: 3.5 }
  };
  var INTS = {
    dezent: { t: 1.5, ok: function (i) { return i <= 2; } },
    ausgewogen: { t: 3, ok: function (i) { return i === 3; } },
    praesent: { t: 4.5, ok: function (i) { return i >= 4; } }
  };
  var SEC = {
    'Frisch': 'Frisch & Klar', 'Grün': 'Frisch & Klar', 'Zitrisch': 'Frisch & Klar', 'Frisch & Klar': 'Frisch & Klar',
    'Warm': 'Warm & Süß', 'Süß': 'Warm & Süß', 'Würzig': 'Warm & Süß', 'Warm & Süß': 'Warm & Süß',
    'Aromatisch': 'Aromatisch & Kräuterig', 'Aromatisch & Kräuterig': 'Aromatisch & Kräuterig',
    'Floral': 'Floral', 'Fruchtig': 'Fruchtig', 'Holzig': 'Holzig'
  };
  var MOMENT_WORDS = {
    zuhause: ['sofa', 'decke', 'wohnzimmer', 'buch', 'kerzen', 'betten', 'familie', 'zu hause', 'herbst', 'sonntag', 'abend'],
    arbeit: ['schreibtisch', 'büro', 'meeting', 'praxis', 'homeoffice', 'laptop', 'montag', 'wartezimmer', 'arbeitszimmer', 'to-do'],
    gaeste: ['gäste', 'empfang', 'lobby', 'hotel', 'laden', 'showroom', 'aperitif', 'dinner', 'freunde'],
    wellness: ['bad', 'wellness', 'yoga', 'tee', 'spa', 'lounge', 'still']
  };

  /* Reihenfolge der Tags = Gewichtung: erster Tag zählt voll, weitere etwas weniger */
  var POS = [1, 0.9, 0.82, 0.76];
  function maxWeight(tags, map) {
    var best = 0;
    (tags || []).forEach(function (t, k) {
      var v = (map[t] || 0) * (POS[k] || 0.7);
      if (v > best) best = v;
    });
    return best;
  }

  function pickMoment(moments, room) {
    var list = moments || [];
    var words = MOMENT_WORDS[room] || [];
    for (var m = 0; m < list.length; m++) {
      var low = String(list[m]).toLowerCase();
      for (var k = 0; k < words.length; k++) {
        if (low.indexOf(words[k]) !== -1) return list[m];
      }
    }
    return room === 'zuhause' ? (list[0] || '') : '';
  }

  function rank(items, a) {
    return items.map(function (it, idx) {
      var s = 0;
      var why = [];
      var w = Number(it.w) || 3;
      var i = Number(it.i) || 3;
      var rm = ROOMS[a.room];
      if (rm) {
        var r = maxWeight(it.rooms, rm);
        s += 3 * r;
        if (r >= 0.75) why.push('room');
      }
      var md = MOODS[a.mood];
      if (md) {
        var at = maxWeight(it.atm, md.atm);
        s += 3 * at - 0.7 * Math.abs(w - md.w);
        if (at >= 0.75) why.push('mood');
      }
      if (a.fam && a.fam !== 'offen') {
        if (it.fam === a.fam) {
          s += 6;
          why.push('fam');
        } else if ((it.sec || []).some(function (x) { return SEC[x] === a.fam; })) {
          s += 2;
          why.push('fam2');
        }
      }
      var ins = INTS[a.int];
      if (ins) {
        s -= Math.abs(i - ins.t);
        if (ins.ok(i)) why.push('int');
      }
      return { it: it, s: Math.round(s * 100) / 100, why: why, idx: idx, moment: pickMoment(it.moments, a.room) };
    }).sort(function (x, y) { return y.s - x.s || x.idx - y.idx; });
  }

  /* Favorit kommt immer aus der gewählten Duftwelt, der zweite Duft ist der beste übrige */
  function pickTop(ranked, a) {
    if (!ranked.length) return [];
    var first = ranked[0];
    if (a.fam && a.fam !== 'offen') {
      for (var k = 0; k < ranked.length; k++) {
        if (ranked[k].it.fam === a.fam) { first = ranked[k]; break; }
      }
    }
    var second = null;
    for (var m = 0; m < ranked.length; m++) {
      if (ranked[m] !== first) { second = ranked[m]; break; }
    }
    return second ? [first, second] : [first];
  }
  /*RANK-END*/

  var KEYS = { 1: 'room', 2: 'mood', 3: 'fam', 4: 'int' };
  var CHECK = '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="m3.5 8.5 3 3 6-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Vorstart: kein Duft hat Bestand (oder Editor-Vorschau) -> kein Warenkorb, Hinweis "Bald erhältlich" */
  function soonMode(data) {
    if (data.preview) return true;
    var items = data.items || [];
    if (!items.length) return false;
    return items.every(function (it) {
      return (it.v || []).every(function (v) { return !v.a; });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-vdf]').forEach(function (root) {
      if (root.dataset.vdfReady) return;
      var dataEl = root.querySelector('[data-vdf-data]');
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      root.dataset.vdfReady = '1';

      var uid = root.dataset.uid;
      var design = !!(window.Shopify && window.Shopify.designMode);
      var useHistory = !design && !!(window.history && history.pushState);
      var L = data.labels || {};
      var SOON = soonMode(data);
      var SOON_BADGE = L.soon || 'Bald erhältlich';
      var SOON_TEXT = L.soonText || 'Deine Empfehlung kannst du dir schon ansehen – bestellbar, sobald VELUN lieferbar ist.';
      var ans = { room: null, mood: null, fam: null, int: null };
      var step = 0;
      var busy = false;

      var intro = root.querySelector('[data-vdf-screen="0"]');
      var quiz = root.querySelector('[data-vdf-quiz]');
      var result = root.querySelector('[data-vdf-screen="5"]');
      var qs = {};
      for (var n = 1; n <= 4; n++) qs[n] = root.querySelector('[data-vdf-screen="' + n + '"]');
      var bar = root.querySelector('[data-vdf-bar]');
      var countEl = root.querySelector('[data-vdf-count]');
      var cardsEl = root.querySelector('[data-vdf-cards]');
      var answersEl = root.querySelector('[data-vdf-answers]');
      var live = root.querySelector('[data-vdf-live]');

      function warm(n) {
        var el = n >= 1 && n <= 4 ? qs[n] : null;
        if (!el) return;
        el.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      }

      function headerOffset() {
        var v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
        return isNaN(v) ? 0 : v;
      }

      function alignTop() {
        var top = root.getBoundingClientRect().top + window.pageYOffset - headerOffset();
        if (Math.abs(window.pageYOffset - top) > 2) {
          window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        }
      }

      function syncPressed() {
        for (var n = 1; n <= 4; n++) {
          var v = ans[KEYS[n]];
          qs[n].querySelectorAll('[data-vdf-opt]').forEach(function (b) {
            b.setAttribute('aria-pressed', b.dataset.vdfOpt === v ? 'true' : 'false');
          });
        }
      }

      function show(n) {
        step = n;
        intro.hidden = n !== 0;
        quiz.hidden = !(n >= 1 && n <= 4);
        result.hidden = n !== 5;
        for (var k = 1; k <= 4; k++) qs[k].hidden = k !== n;
        if (n >= 1 && n <= 4) {
          bar.style.setProperty('--vdf-p', (n * 25) + '%');
          bar.setAttribute('aria-valuenow', String(n));
          countEl.textContent = n;
        }
        if (n === 5) renderResults();
        syncPressed();
        warm(n + 1);
        var h = root.querySelector('#' + uid + '-t' + n);
        if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
      }

      function goTo(n, push) {
        show(n);
        alignTop();
        if (push && useHistory) history.pushState({ vdf: uid, step: n }, '');
      }

      function back() {
        if (useHistory && history.state && history.state.vdf === uid && history.state.step > 0) {
          history.back();
        } else {
          goTo(Math.max(0, step - 1), false);
        }
      }

      function answerLabels() {
        var out = [];
        if (ans.room && L.room) out.push(L.room[ans.room]);
        if (ans.mood && L.mood) out.push(L.mood[ans.mood]);
        if (ans.fam) out.push(ans.fam === 'offen' ? (L.offen || 'Offen') : ans.fam);
        if (ans.int && L.int) out.push(L.int[ans.int]);
        return out.filter(Boolean);
      }

      function whyChips(r) {
        var out = [];
        r.why.forEach(function (k) {
          if (k === 'room' && L.room) out.push(L.room[ans.room]);
          if (k === 'mood' && L.mood) out.push(L.mood[ans.mood]);
          if (k === 'fam') out.push(r.it.fam);
          if (k === 'fam2') out.push('Note ' + ans.fam);
          if (k === 'int' && L.int) out.push(L.int[ans.int]);
        });
        return out.filter(Boolean);
      }

      function cardHTML(r, pos) {
        var it = r.it;
        var fam = (data.fams || {})[it.fam] || {};
        var v = (it.v || [])[0] || {};
        var img = it.mood || it.img;
        var chips = whyChips(r);
        var html = '';
        html += '<article class="vdf__card' + (pos === 0 ? ' vdf__card--fav' : '') + '" style="--vdf-tint:' + esc(fam.t || '') + ';--vdf-dot:' + esc(fam.d || '') + ';--vdf-d:' + (pos * 120) + 'ms" data-vid="' + esc(v.id || 0) + '">';
        html += '<div class="vdf__card-media">';
        if (img) html += '<img class="vdf__card-img" src="' + esc(img) + '" alt="' + esc(it.name + ' – ' + it.notes) + '" loading="eager">';
        html += '<span class="vdf__card-tag">' + esc(pos === 0 ? L.fav : L.alt) + '</span></div>';
        html += '<div class="vdf__card-body">';
        html += '<span class="vdf__card-kicker"><span class="vdf__card-dot" aria-hidden="true"></span>' + esc(it.n) + ' · ' + esc(it.fam) + '</span>';
        html += '<h3 class="vdf__card-name">' + esc(it.name) + '</h3>';
        if (it.claim) html += '<p class="vdf__card-claim">' + esc(it.claim) + '</p>';
        if (it.notes) html += '<p class="vdf__card-notes">' + esc(it.notes) + '</p>';
        if (chips.length) {
          html += '<ul class="vdf__why" role="list" aria-label="Passt zu deinen Antworten">';
          chips.forEach(function (c) { html += '<li>' + CHECK + esc(c) + '</li>'; });
          html += '</ul>';
        }
        if (r.moment) html += '<p class="vdf__moment"><span>' + esc(L.moment) + '</span> ' + esc(r.moment) + '</p>';
        if ((it.v || []).length > 1) {
          html += '<div class="vdf__sizes" role="group" aria-label="Größe">';
          it.v.forEach(function (vv, k) {
            html += '<button type="button" class="vdf__size" data-vdf-size="' + k + '" aria-pressed="' + (k === 0 ? 'true' : 'false') + '">' + esc(vv.t) + '<small>' + esc(vv.p) + '</small></button>';
          });
          html += '</div>';
        }
        html += '<div class="vdf__card-actions">';
        if (SOON) {
          html += '<span class="vdf__badge">' + esc(SOON_BADGE) + '</span>';
          html += '<p class="vdf__card-notes">' + esc(SOON_TEXT) + '</p>';
          html += '<div class="vdf__card-links">';
          html += '<a class="vdf__link" href="' + esc(it.url) + '">' + esc(L.view) + '<span aria-hidden="true">→</span></a>';
          html += '</div>';
        } else {
          html += '<button type="button" class="vdf__btn vdf__add" data-vdf-add>' + esc(L.cart) + '</button>';
          html += '<div class="vdf__card-links">';
          html += '<a class="vdf__link" href="' + esc(it.url) + '">' + esc(L.view) + '<span aria-hidden="true">→</span></a>';
          html += '<a class="vdf__link" href="' + esc(cartUrl()) + '" data-vdf-cartlink hidden>Zum Warenkorb<span aria-hidden="true">→</span></a>';
          html += '</div>';
          html += '<p class="vdf__err" data-vdf-err hidden></p>';
        }
        html += '</div></div></article>';
        return html;
      }

      function rootUrl() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }
      function cartUrl() { return rootUrl() + 'cart'; }

      function setVariant(card, item, k) {
        var v = (item.v || [])[k] || {};
        card.dataset.vid = v.id || 0;
        card.querySelectorAll('[data-vdf-size]').forEach(function (b) {
          b.setAttribute('aria-pressed', Number(b.dataset.vdfSize) === k ? 'true' : 'false');
        });
        var add = card.querySelector('[data-vdf-add]');
        if (!add) return;
        add.classList.remove('is-added');
        var cl = card.querySelector('[data-vdf-cartlink]');
        if (cl) cl.hidden = true;
        if (data.preview || !v.id) {
          add.disabled = true;
          add.textContent = L.cart;
        } else if (!v.a) {
          add.disabled = true;
          add.textContent = 'Derzeit nicht verfügbar';
        } else {
          add.disabled = false;
          add.textContent = L.cart;
        }
      }

      function addToCart(card, item) {
        var add = card.querySelector('[data-vdf-add]');
        var err = card.querySelector('[data-vdf-err]');
        var vid = Number(card.dataset.vid);
        if (!add || !vid || add.disabled) return;
        add.disabled = true;
        add.setAttribute('aria-busy', 'true');
        add.textContent = 'Wird hinzugefügt …';
        err.hidden = true;
        fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        })
          .then(function (res) {
            return res.json().then(function (j) { if (!res.ok) throw j; return j; });
          })
          .then(function () {
            return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            add.removeAttribute('aria-busy');
            add.classList.add('is-added');
            add.textContent = 'Im Warenkorb ✓';
            card.querySelector('[data-vdf-cartlink]').hidden = false;
            var size = card.querySelector('[data-vdf-size][aria-pressed="true"]');
            if (live) live.textContent = item.name + (size ? ' ' + size.firstChild.textContent : '') + ' liegt im Warenkorb.';
            try {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: cart, sourceId: uid, data: { itemCount: cart.item_count, source: 'velun-finder' } }
              }));
            } catch (e) {}
          })
          .catch(function (e) {
            add.removeAttribute('aria-busy');
            add.disabled = false;
            add.textContent = L.cart;
            err.textContent = (e && (e.description || e.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
            err.hidden = false;
          });
      }

      function renderResults() {
        var items = data.items || [];
        var top = pickTop(rank(items, ans), ans);
        answersEl.innerHTML = answerLabels().map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
        cardsEl.innerHTML = top.map(cardHTML).join('');
        cardsEl.querySelectorAll('.vdf__card').forEach(function (card, k) {
          var item = top[k].it;
          setVariant(card, item, 0);
          card.querySelectorAll('[data-vdf-size]').forEach(function (b) {
            b.addEventListener('click', function () { setVariant(card, item, Number(b.dataset.vdfSize)); });
          });
          var addBtn = card.querySelector('[data-vdf-add]');
          if (addBtn) addBtn.addEventListener('click', function () { addToCart(card, item); });
        });
      }

      /* Ereignisse */
      var start = root.querySelector('[data-vdf-start]');
      if (start) start.addEventListener('click', function () { goTo(1, true); });
      root.querySelector('[data-vdf-back]').addEventListener('click', back);
      root.querySelector('[data-vdf-restart]').addEventListener('click', function () {
        ans = { room: null, mood: null, fam: null, int: null };
        goTo(1, true);
      });

      for (var q = 1; q <= 4; q++) {
        (function (qn) {
          qs[qn].querySelectorAll('[data-vdf-opt]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              if (busy || step !== qn) return;
              busy = true;
              ans[KEYS[qn]] = btn.dataset.vdfOpt;
              syncPressed();
              setTimeout(function () {
                busy = false;
                goTo(qn + 1, true);
              }, 280);
            });
          });
        })(q);
      }

      if (useHistory) {
        history.replaceState({ vdf: uid, step: 0 }, '');
        window.addEventListener('popstate', function (e) {
          var st = e.state;
          if (st && st.vdf === uid) {
            show(st.step);
            alignTop();
          } else if (step !== 0) {
            show(0);
          }
        });
      }

      if (document.readyState === 'complete') warm(1);
      else window.addEventListener('load', function () { warm(1); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
